document.addEventListener('DOMContentLoaded', async function () {
    // Auto add secure shipping is disabled, for now
    return;

    const shippingId = window.slsTheme.secureShippingProductId;

    if (!shippingId) {
        return;
    }

    async function addShippingProtection() {
        const cart = await (await fetch('/cart.js')).json();

        if (
            cart.items.length === 0 &&
            !cart.attributes?.['shipping_protection_added'] &&
            !cart.items.some(item => item.variant_id == shippingId)
        ) {

            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    id: shippingId,
                    quantity: 1,
                    attributes: {
                        'shipping_protection_added': true,
                    },
                }),
            });

            document.dispatchEvent(new CustomEvent('cart:reload', {
                bubbles: true
            }));
        }
    }

    document.addEventListener('cart:created', addShippingProtection);
    await addShippingProtection();

    document.addEventListener('cart:count:update', async (event) => {
        const cart = await (await fetch('/cart.js')).json();

        if (
            cart.items.length > 1 &&
            cart.attributes?.['shipping_protection_added'] &&
            cart.items.some(item => item.variant_id == shippingId)
        ) {
            document.querySelector("hdt-cart-count").textContent = (cart.item_count - 1).toString();
        }
    });
});